export {
  Typography,
  NAMES,
  type TypographyProps,
  type TypographyNameType,
  type TypographyTagType,
} from './Typography';
